import { useBreakpoints, breakpointsTailwind } from '@vueuse/core';


export default {
  __name: 'CatalogFilterHeader',
  props: {
  isFiltersOpen: {
    type: Boolean,
    default: false,
  },
  enableSwitchFilters: {
    type: Boolean,
    default: true,
  },
},
  emits: ['toggle-filters', 'toggle-mobile-filters'],
  setup(__props, { emit }) {



const { isGreater } = useBreakpoints(breakpointsTailwind);



const toggleFilters = () => {
  if (isGreater('lg')) {
    emit('toggle-filters');
  } else {
    emit('toggle-mobile-filters');
  }
};

return { __sfc: true,isGreater, emit, toggleFilters }
}

}